import estado_solicitud_model from '@/shared/models/estado_solicitud_model';

const hoy = new Date();
const FechaDesde = new Date(hoy);
FechaDesde.setDate(hoy.getDate() - 60);
FechaDesde.setHours(0, 0, 0, 0);

export default {
  FechaDesde,
  FechaHasta: new Date(new Date().setHours(23, 59, 59, 999)),
  Estado: { ...estado_solicitud_model },
  CodigoUsuarioCreacion: null,
  FechaEstadoDesde: null,
  FechaEstadoHasta: new Date(new Date().setHours(23, 59, 59, 999)),
  Cliente: null,
  Referencia: null,
  CodigoEquivalente: null,
  CodigoAdicional: null,
  ElementoTipo: null,
  Suaje: null,
  CodigoEspecificacionTecnica: null,
  FiltroVigencia: null,
  DescripcionComercial: null,
  CodigoUsabilidad: null,
  Procesos: [],
  version: null,
  CodigoET: null,
};
